import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const SaintBarthelemy: Country = {
    identifier: "SaintBarthelemy",
    name: "Saint Barthelemy",
    countryCode: "BL",
    group: CountryGroup.CENTRAL_AMERICA,
    isUNMember: false,
    flag: "🇧🇱",
    svgPath: "m 298.55875,412.2484 -0.043,0.003 -0.033,-0.024 -0.03,-0.044 -0.017,-0.044 0.004,-0.026 0.025,0.012 0.184,0.028 -0.02,0.033 -0.032,0.035 z",
}
